import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiRefreshCollectionOwnerVariables = Types.Exact<{
  chainId: Types.Scalars['ChainId'];
  contractAddress: Types.Scalars['Address'];
}>;


export type ApiRefreshCollectionOwner = { refreshCollectionOwner: boolean };



export const ApiRefreshCollectionOwnerDocument = /*#__PURE__*/ `
    mutation RefreshCollectionOwner($chainId: ChainId!, $contractAddress: Address!) {
  refreshCollectionOwner: refreshCollectionOwnerV2(
    collection: {chainId: $chainId, contractAddress: $contractAddress}
  )
}
    `;

export const useRefreshCollectionOwner = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiRefreshCollectionOwner, TError, ApiRefreshCollectionOwnerVariables, TContext>) => {
    
    return useMutation<ApiRefreshCollectionOwner, TError, ApiRefreshCollectionOwnerVariables, TContext>(
      {
    mutationKey: ['RefreshCollectionOwner'],
    mutationFn: (variables?: ApiRefreshCollectionOwnerVariables) => apiFetcher<ApiRefreshCollectionOwner, ApiRefreshCollectionOwnerVariables>(ApiRefreshCollectionOwnerDocument, variables)(),
    ...options
  }
    )};


useRefreshCollectionOwner.fetcher = (variables: ApiRefreshCollectionOwnerVariables, options?: RequestInit['headers']) => apiFetcher<ApiRefreshCollectionOwner, ApiRefreshCollectionOwnerVariables>(ApiRefreshCollectionOwnerDocument, variables, options);
